import { decorateWith } from 'helpers/decorator';
import { withSagas } from 'decorators/Sagas/Sagas';
import { loadSaga, watchSaga } from './OfferBannerLoader.saga';

export const OfferBannerLoaderUnwrapped = () => null;

export const OfferBannerLoader = decorateWith(
  withSagas({
    load: loadSaga,
    watch: watchSaga,
  })
)(OfferBannerLoaderUnwrapped);
